import React, { Suspense, lazy } from "react"
import { Loader2 } from "lucide-react"

const LazyDemoTableau = lazy(() => import("./DemoTableauViewer"))

const DemoTableauWrapper = (props) => (
  <Suspense
    fallback={
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Loader2 className="animate-spin" size={32} />
      </div>
    }
  >
    <LazyDemoTableau {...props} />
  </Suspense>
)

export default DemoTableauWrapper
